"use client";
import { useEffect } from "react";

/**
 *
 * This file provides a React component that initializes the Ada chat bot embed on the client side.
 *
 * Defines a utility function `waitForAdaEmbedAndOpenChat` that checks for a query parameter (`open_chat_bot=true`)
 * If present, waits for the Ada embed to load before programmatically opening the chat bot.
 * The default exported React component (`AdaEmbedInitializer`) runs this logic in a `useEffect` hook,
 *   ensuring it only executes on the client and only once on mount.
 * The component does not render any UI.
 */

declare global {
  interface Window {
    adaEmbed?: {
      toggle: () => void;
      setMetaFields: (fields: {
        existing_token?: string;
        gatsbytoken?: string;
        order?: string;
      }) => void;
    };
  }
}

function waitForAdaEmbedAndOpenChat(maxWaitMs = 10000, pollInterval = 100) {
  const params = new URLSearchParams(window.location.search);
  if (params.get("open_chat_bot") !== "true") {
    return;
  }
  const start = Date.now();
  (function poll() {
    if (typeof window.adaEmbed?.toggle === "function") {
      window.adaEmbed.toggle();
    } else if (Date.now() - start < maxWaitMs) {
      setTimeout(poll, pollInterval);
    } else {
      // eslint-disable-next-line no-console
      console.error("Ada embed not found");
    }
  })();
}

export function AdaEmbedInitializer(): null {
  useEffect(() => {
    waitForAdaEmbedAndOpenChat();
  }, []);
  return null;
}
